// extracted by mini-css-extract-plugin
export default {"accordionPreview":"accordionPreview__Vfi+b","wide":"wide__ofuQz","image":"image__GDP5P","text":"text__AmSmi","reason":"reason__lSQjx","title":"title__RObBj"};